var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#F7F7F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 6.25H12.5C12.8452 6.25 13.125 6.52981 13.125 6.875V13.125C13.125 13.4702 12.8452 13.75 12.5 13.75H2.5C2.15483 13.75 1.875 13.4702 1.875 13.125V6.875C1.875 6.52981 2.15483 6.25 2.5 6.25H3.125V5.625C3.125 3.20876 5.08376 1.25 7.5 1.25C9.91625 1.25 11.875 3.20876 11.875 5.625V6.25ZM3.125 7.5V12.5H11.875V7.5H3.125ZM6.875 8.75H8.125V11.25H6.875V8.75ZM10.625 6.25V5.625C10.625 3.89911 9.22587 2.5 7.5 2.5C5.77411 2.5 4.375 3.89911 4.375 5.625V6.25H10.625Z",
    fill: "url(#paint0_linear_115_15276)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 8.5V11.5H6.5V8.5H8.5Z",
    fill: "url(#paint1_linear_115_15276)",
    stroke: "#F7F7F7",
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_115_15276",
    x1: 1.875,
    y1: 7.5,
    x2: 13.125,
    y2: 7.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#026D4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#21B389"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_115_15276",
    x1: 7,
    y1: 10,
    x2: 8,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8C745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AF7B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock2);
export default __webpack_public_path__ + "static/media/lock2.621ac8a595f2b52a4d34ba9c73555cf3.svg";
export { ForwardRef as ReactComponent };